import React from 'react';
import { chunk } from 'lodash-es';
import classNames from 'classnames';

interface IColumnBulletPointsProps {
  items: string[];
  cols?: number;
  direction?: 'vertical' | 'horizontal';
  wrapperClassName?: string;
  ulClassName?: string;
  liClassName?: string;
}

export const ColumnBulletPoints = (props: IColumnBulletPointsProps) => {
  let { items, cols = 1, direction = 'vertical', wrapperClassName, ulClassName, liClassName } = props;

  if (cols > items.length) {
    cols = items.length;
  }
  if (direction === 'vertical') {
    const divider = Math.ceil(items.length / cols);
    const chunks = chunk(items, divider);
    return (
      <div
        className={classNames('grid font-pt-sans', wrapperClassName)}
        style={{
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
        }}
      >
        {chunks.map((chunk, chunkIdx) => (
          <ul key={chunk[0]} className={classNames('m-0', ulClassName)}>
            {chunk.map((item, itemIdx) => (
              <li key={`${chunkIdx}-${itemIdx}`} className={liClassName}>
                {item}
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  }

  if (direction === 'horizontal') {
    const chunks = chunk(items, cols);

    return (
      <div
        className={classNames('grid', wrapperClassName)}
        style={{
          gridTemplateColumns: `repeat(${cols}, 1fr)`,
        }}
      >
        {Array.from({ length: cols }, (_, colIdx) => (
          <ul key={`col-${colIdx}`} className={ulClassName}>
            {chunks.map((chunk, rowIdx) =>
              chunk[colIdx] ? (
                <li key={`${colIdx}-${rowIdx}`} className={liClassName}>
                  {chunk[colIdx]}
                </li>
              ) : null
            )}
          </ul>
        ))}
      </div>
    );
  }

  return null;
};
